// == THIRD PARTY SCRIPTS ==

// TetherJS [required for bootstrap popover and tooltips]
// OFF = vendor/tether.js

// Custom Bootstrap 4 scripts: affix, collapse, tabs & transitions
//= vendor/bootstrap.js

// Parallax Effect for homepage intro
//= vendor/parallax.js

// Alternative ScrollSpy
//= vendor/scrollSpy.js

// Smooth scroll for Chrome
//= vendor/chrome-smooth-scroll.js

// jQuery Cookies
// Home: https://github.com/carhartl/jquery-cookie
//= vendor/jquery.cookies.js

// jQuery URL
//= vendor/jquery.url.js

// jQuery Steps
//= vendor/select2.js

// jQuery Validation
//= vendor/jquery.validation.js

// jQuery SmartWizard
//= vendor/smartWizard.js

// == DEVBYTES SCRIPTS ==

// Utils
//= dev/dev-utils.js

// Yandex Metrika
//= dev/dev-metrika.js

// Browser detect
//= dev/dev-detect-browser.js

// Browser detect
//= dev/dev-detect-mobile.js

// Validator
//= dev/dev-validators.js

// Other Features
//= dev/dev-features.js

// Other Features
//= dev/dev-chat.js

// Notifiers
//= dev/dev-notifiers.js

// Document.ready
$(function() {
    "use strict"; // Start of use strict

    // GLOBAL TSM SCRIPTS
    //= pages/tsm-global.js

    // INDIVIDUAL SCRIPTS PAGES
    // Scripts for homepage
    //= pages/tsm-homepage.js

    // Scripts for writer_login page
    //= pages/tsm-login.js

    // Scripts for writer_login page
    //= pages/tsm-forgot.js

    // Scripts for Regform
    //= pages/tsm-signup.js

    // Get price sheet
    //= pages/tsm-prices.js

}); // End of use strict
